import * as React from 'react';
import * as PropTypes from 'prop-types';
import classNames from 'classnames';
import ChevronRight from '@material-ui/icons/ChevronRight';
import ExpandMore from '@material-ui/icons/ExpandMore';
import IconButton from 'material-ui/IconButton';
import { TableCell } from 'material-ui/Table';
import { withStyles } from 'material-ui/styles';

const styles = theme => ({
    cell: {
        cursor: 'pointer',
        paddingLeft: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
        paddingTop: theme.spacing.unit / 2 - 1
    },
    indentCell: {
        padding: 0
    },
    groupButton: {
        verticalAlign: 'middle',
        display: 'inline-block',
        height: theme.spacing.unit * 5,
        width: theme.spacing.unit * 5,
        marginRight: theme.spacing.unit
    },
    columnTitle: {
        verticalAlign: 'middle'
    }
});

const defaultGrouping = [{ columnName: 'portfolio' }, { columnName: 'brand' }, { columnName: 'financeCompanyName' }];

const TableGroupCellBase = ({
    style,
    colSpan,
    row,
    column,
    expanded,
    onToggle,
    classes,
    children,
    className,
    tableRow,
    tableColumn,
    ...restProps
}) => {
    const doNothing = () => {};
    const handleClick = () => onToggle();
    const offset = (defaultGrouping
        .findIndex(col => col.columnName === column.name));
    if (tableColumn.column.name === 'financeCompanyName') {
        // We do not want to have detailed rows for alert report
        return <TableCell
          colSpan={colSpan - 2}
          style={offset !== 0 ? { paddingLeft: `${offset * 20}%` } : { paddingLeft: 10 }}
          className={classNames(classes.cell, className)}
          onClick={doNothing}
          disabled
          {...restProps}
        >
            <span className={classes.columnTitle}>{children || row.value}</span>
        </TableCell>;
    }
    return (
        <TableCell
            colSpan={colSpan - 2}
            style={offset !== 0 ? { paddingLeft: `${offset * 20}%` } : { paddingLeft: 10 }}
            className={classNames(classes.cell, className)}
            onClick={handleClick}
            {...restProps}
        >
            <IconButton className={classes.groupButton}>
                {expanded ? <ExpandMore /> : <ChevronRight />}
            </IconButton>
            <span className={classes.columnTitle}>{children || row.value}</span>
        </TableCell>
    );
};

TableGroupCellBase.propTypes = {
    style: PropTypes.object,
    colSpan: PropTypes.number,
    row: PropTypes.any,
    column: PropTypes.object,
    expanded: PropTypes.bool,
    onToggle: PropTypes.func,
    classes: PropTypes.object.isRequired,
    children: PropTypes.node,
    className: PropTypes.string,
    tableRow: PropTypes.object,
    tableColumn: PropTypes.object
};

TableGroupCellBase.defaultProps = {
    style: null,
    colSpan: 1,
    row: {},
    column: {},
    expanded: false,
    onToggle: () => { },
    children: undefined,
    className: undefined,
    tableRow: undefined,
    tableColumn: undefined
};

export default withStyles(styles, { name: 'TableGroupCell' })(TableGroupCellBase);


// WEBPACK FOOTER //
// ./src/helpers/TableGroupCell.js